import InstitutionFuturesExecutionOnboardingForm from '@/features/institution/futures/execution/components/onboarding-form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingExecutionPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="execution" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionFuturesExecutionOnboardingForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingExecutionPage.displayName = 'InstitutionOnboardingExecutionPage';

export default InstitutionOnboardingExecutionPage;
